
export const TOASTDURATION = 2000
export const kLoginInfo = 'loginInfo';

/**
 * 获取登陆账号信息
 */
export function getLoginUserInfo () : API.CurrentUser | null {
    const data: string | null = window.localStorage.getItem(kLoginInfo);
    if (data) {
        const curUserData: API.CurrentUser = JSON.parse(data) as  API.CurrentUser;
        if (curUserData) {
            return curUserData;
        }
    }
    return null
}
